import Cookies from '../../../../common/Cookies';
import Logger from '../../../../common/logger';

const EIP_COOKIE = 'EIP';

const processEvents = (action) => {
    const processEventListeners = ({ target, action, eventName, callback }) => {
        switch (action.toUpperCase()) {
            case 'ADD':
                target.addEventListener(eventName, callback, false);
                break;
            case 'REMOVE':
                target.removeEventListener(eventName, callback);
                break;
            default:
                break;
        }
    };

    Object.keys(Events).forEach((key) => {
        processEventListeners({
            target: key === 'scroll' ? window : document,
            action: action,
            eventName: key,
            callback: Events[key]
        });
    });

    if (!ExitIntent.options.inactiveTimeout) {
        return;
    }
    if (action === 'add') {
        InactivityTimer.start();
    } else if (action === 'remove') {
        InactivityTimer.stop();
    }
};

const openPopup = (trigger) => {
    Logger.log(`ExitIntent: openPopup.trigger=${trigger}`);
    if (ExitIntent.callbacks.onOpen) {
        if (ViewCounter.check()) {
            ViewCounter.increase();
            ExitIntent.callbacks.onOpen(trigger);
        } else {
            Logger.log('ExitIntent: views per period exceeded');
        }
    }
    processEvents('remove');
};

const ExitIntent = {
    options: null,
    callbacks: null
};

const InactivityTimer = {
    idleTime: 0,
    idleInterval: null,
    start: () => {
        InactivityTimer.idleTime = 0;
        const timerIncrement = () => {
            InactivityTimer.idleTime = InactivityTimer.idleTime + 1;
            if (InactivityTimer.idleTime > ExitIntent.options.inactiveTimeout) {
                openPopup('popup-inactive');
            }
        };
        InactivityTimer.idleInterval = setInterval(timerIncrement, 1000);
    },
    stop: () => {
        clearInterval(InactivityTimer.idleInterval);
        InactivityTimer.idleInterval = null;
    }
};

let scrollTimeoutId = 0;
const Events = {
    mousemove: (e) => {
        InactivityTimer.idleTime = 0;
        if (!ExitIntent.options.topBorder) {
            return;
        }
        if (e.clientY > 10) {
            return;
        }
        if (ExitIntent.options.topBorderWidthPercentage) {
            const isMatch =
                e.clientX >
                e.view.window.innerWidth -
                    (e.view.window.innerWidth * ExitIntent.options.topBorderWidthPercentage) / 100;
            Logger.log(`topBorderWidthPercentage: ${isMatch}`);
            if (!isMatch) {
                return;
            }
        }

        openPopup('popup-topBorder');
    },
    keypress: () => {
        InactivityTimer.idleTime = 0;
    },
    scroll: () => {
        if (!ExitIntent.options.scrollPercentage) {
            return;
        }
        window.clearTimeout(scrollTimeoutId);
        scrollTimeoutId = window.setTimeout(() => {
            const h = document.documentElement,
                b = document.body,
                st = 'scrollTop',
                sh = 'scrollHeight';

            const percent = ((h[st] || b[st]) / ((h[sh] || b[sh]) - h.clientHeight)) * 100;

            Logger.log(`Scroll percent: ${percent}`);
            if (percent > parseInt(ExitIntent.options.scrollPercentage)) {
                window.clearTimeout(scrollTimeoutId);
                openPopup('popup-scroll');
            }
        }, 300);
    }
};

const ViewCounter = {
    check: () => {
        if (!ExitIntent.options.viewsLimit || !ExitIntent.options.viewsPeriod) {
            return true;
        }

        const cookie = Cookies.getItem(EIP_COOKIE);
        if (!cookie) {
            return true;
        }

        const values = cookie.split(';');
        if (values.length !== 2) {
            return true;
        }

        if (parseInt(values[0]) === ExitIntent.options.viewsLimit) {
            return false;
        } else {
            return true;
        }
    },
    increase: () => {
        if (!ExitIntent.options.viewsLimit || !ExitIntent.options.viewsPeriod) {
            return;
        }

        const cookie = Cookies.getItem(EIP_COOKIE);
        if (!cookie) {
            const expires = new Date();
            expires.setTime(
                expires.getTime() + parseInt(ExitIntent.options.viewsPeriod) * 24 * 60 * 60 * 1000
            );
            Cookies.setItem(EIP_COOKIE, '1;' + expires.toISOString(), expires);
        } else {
            const values = cookie.split(';');
            Cookies.setItem(
                EIP_COOKIE,
                parseInt(values[0]) + 1 + ';' + values[1],
                new Date(values[1])
            );
        }
    }
};

ExitIntent.init = (options, callbacks) => {
    ExitIntent.options = options;
    ExitIntent.callbacks = callbacks;
    processEvents('add');
};

export default ExitIntent;
